import { useEffect } from 'react';
import { useIsFetching } from 'react-query';

export const useOnLayoutChangeEffect = (cb: () => void, deps?: any[], debounce?: number) => {
  const isFetching = useIsFetching();

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;

    const effect = () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(cb, debounce || 10);
    };

    window.addEventListener('resize', effect);

    effect();

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      window.removeEventListener('resize', effect);
    };
  }, [cb, isFetching, ...(deps || [])]);
};
